import React, {useState} from "react";
import {useHistory} from "react-router-dom";
import PropTypes from "prop-types";
import "./styles.scss";
import Form from "../../../../containers/Chat/ChatBotFreeQuestion/Form";
import Messages from "../../../../containers/Chat/ChatBotFreeQuestion/Messages";
import Wrapper from "../../Layout/Wrapper/Wrapper";
import MessagerieWrapper from "../../Layout/MessagerieWrapper/MessagerieWrapper";
import ChatTitle from "../../shared/ChatTitle/ChatTitle";
import ContainerMessagerie from "../../Layout/ContainerMessage/ContainerMessagerie";
import ColoneChatInfos from "../../shared/ColoneChatInfos/ColoneChatInfos";
import Nav from "../../../../containers/Nav/Nav";
import useWindowDimensions from "../../../../hook/useWindowDimension";

const FreeQuestionChatBot = ({dataUser, openFreeQuestionChatBot}) => {
    const history = useHistory();
    const {width} = useWindowDimensions();
    const [displayQuestions, setDisplayQuestions] = useState(true);
    return (
        <Wrapper>
            {width > 599 &&
                <Nav
                    setDisplayQuestions={setDisplayQuestions}
                />
            }
            <MessagerieWrapper>
                <ChatTitle caremanagerName="Prev&Care" freeQuestion onclick={() => history.push("/")}/>
                <ContainerMessagerie>
                    <Messages/>
                </ContainerMessagerie>
                <Form/>
            </MessagerieWrapper>
            <ColoneChatInfos rappel={false} enableDocument={false} dataUser={dataUser}
                             openFreeQuestionChatBot={openFreeQuestionChatBot}/>
        </Wrapper>
    );
};

FreeQuestionChatBot.propTypes = {
    setInputValue: PropTypes.func,
    inputValue: PropTypes.string,
    dataUser: PropTypes.object,
    openFreeQuestionChatBot: PropTypes.bool
};

export default FreeQuestionChatBot;